<template>
<div class="chapter">
<div class="inner_page">
<div style="page-break-before: always;"></div>
<p class="P_Norm-NoIndent__And__Page_Break" id="auto_bookmark_toc_1"><span style=" font-style: italic; font-size: 1.00em;">« Les écologistes s’inquiétaient des conséquences de la réintroduction du loup gris en Grande-Bretagne. Ce qu’ils ne savaient pas, c’était que nous ne l’avions jamais quittée. »</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0004.vue?bfd313ea